import { useLocation } from 'react-router-dom';
import { map } from 'lodash';

export const useUpdateSelected = () => {
  const { pathname } = useLocation();

  const defaultGetIsSelected = (pathname: string, item: { url: string }) =>
    pathname === item.url || pathname.includes(item.url + '/');

  return <
    Item extends {
      url: string;
      getIsSelected?: (pathname: string, item: Item) => boolean;
    }
  >(
    items: Item[]
  ): (Item & { isSelected: boolean })[] =>
    map(items, (item) => {
      const getIsSelected = item.getIsSelected || defaultGetIsSelected;
      const isSelected = getIsSelected(pathname, item);

      return {
        ...item,
        isSelected,
      };
    });
};
